import { DOWNLOAD_TYPES } from "../../constants";

export const isDownloadingAllowed = (status: DOWNLOAD_TYPES): boolean =>
  status === DOWNLOAD_TYPES.DOWNLOADING_ALLOWED;

export const isDownloading = (status: DOWNLOAD_TYPES): boolean =>
  status === DOWNLOAD_TYPES.DOWNLOADING;

export const isDownloaded = (status: DOWNLOAD_TYPES): boolean =>
  status === DOWNLOAD_TYPES.DOWNLOADED;

export const isDownloadingError = (status: DOWNLOAD_TYPES): boolean =>
  status === DOWNLOAD_TYPES.DOWNLOADING_ERROR;
